import { render, staticRenderFns } from "./create.vue?vue&type=template&id=954c6b0e&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=954c6b0e&prod&scoped=true&lang=css"
import style1 from "./create.vue?vue&type=style&index=1&id=954c6b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954c6b0e",
  null
  
)

export default component.exports